<template>
  <div id="app">
    <Header></Header>
    <router-view class="body" />
    <Footer class="footer"></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    setTimeout(()=>{
      const bd = document.querySelector(".body")
      const footer = document.querySelector(".footer")
      bd.style.marginBottom = footer.offsetHeight + 'px'
    },1000)
  }
}
</script>

<style>
::-webkit-scrollbar {
  display: none;
}
.footer{
  position: fixed;
  bottom: 0;
}

</style>



// WEBPACK FOOTER //
// src/App.vue